import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MercadoPagoService {
  private mercadoPagoUrl = 'https://api.mercadopago.com';
  private accessToken = 'APP_USR-3174381674299323-082217-7b8b46990b9acc58b3c415e0240de7cc-1087143768'; // Pon aquí tu access token de MercadoPago
  public passApi = 'edbce914409ab6a733e2e527fbe4349b';
  private tokenApp = '142f1c01254127506592cf5e94910369';
  public montoMinimoRecargaTarjeta = 100;
  constructor(private http: HttpClient) {}

  // Crear preferencia de pago
  createPaymentPreference(items: any[], backUrls: any, payerInfo?: any): Observable<any> {
    const url = `${this.mercadoPagoUrl}/checkout/preferences`;

    const headers = {
      Authorization: `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    };

    const body = {
      items: items,
      payer: payerInfo || {},
      back_urls: backUrls,
    };

    return this.http.post(url, body, { headers });
  }

  getPassApi() {
    return this.passApi;
  }

  getTokenApp() {
    return this.tokenApp;
  }

  getmontoMinimoRecargaTarjeta() {
    return this.montoMinimoRecargaTarjeta;
  }

  // Obtener el estado de un pago por ID
  getPaymentStatus(paymentId: string): Observable<any> {
    const url = `${this.mercadoPagoUrl}/v1/payments/${paymentId}`;
    const headers = {
      Authorization: `Bearer ${this.accessToken}`,
    };

    return this.http.get(url, { headers });
  }

  // Cancelar un pago por ID
  cancelPayment(paymentId: string): Observable<any> {
    const url = `${this.mercadoPagoUrl}/v1/payments/${paymentId}`;
    const headers = {
      Authorization: `Bearer ${this.accessToken}`,
    };

    return this.http.put(url, { status: 'cancelled' }, { headers });
  }

  // Buscar pagos con filtros
  searchPayments(filters: any): Observable<any> {
    const url = `${this.mercadoPagoUrl}/v1/payments/search`;
    const headers = {
      Authorization: `Bearer ${this.accessToken}`,
    };

    return this.http.get(url, { headers, params: filters });
  }
}
